import * as moment from 'moment';

const isInfiniteLimit = (accountLimit: number | undefined | null) =>
  accountLimit === null || accountLimit === undefined;

export function hideRecordingsNotAvailableInPlan<
  T extends {
    createdAt?: any;
    recordingAvailable?: boolean;
    startDate?: any;
    recordingExists?: boolean;
  }
>(recordingsStorageDays: number | undefined | null, object: T): T {
  if (isInfiniteLimit(recordingsStorageDays)) {
    return object;
  }
  const eventDate = moment(object.createdAt);
  const eventRecordingAvailableInPlan = moment().diff(eventDate, 'days') < recordingsStorageDays;
  const recordingAvailable = object.recordingAvailable && eventRecordingAvailableInPlan;

  const callStartDate = moment(object.startDate);
  const callRecordingAvailableInPlan = moment().diff(callStartDate, 'days') < recordingsStorageDays;
  const recordingExists = object.recordingExists && callRecordingAvailableInPlan;

  return { ...(object as object), recordingAvailable, recordingExists } as T;
}
